import {
  DASHBOARD2_TODAY_SIDE_BOOKINGS_FIT_MIN_WIDTH_PX,
  DASHBOARD2_TODAY_WIDE_HINT_FIT_MIN_WIDTH_PX,
  DASHBOARD2_TODAY_WIDE_SIDE_HIDE_HYSTERESIS_PX
} from "../dashboard2.styles";

export type TodayWideSideVisibilityInput = {
  contentWidth: number;
  additionalCount: number;
  hasListedAdditionalBookings: boolean;
  sideCurrentlyVisible: boolean;
};

export type TodayWideSideVisibilityResult = {
  showSideContent: boolean;
  showInlineAdditionalBookings: boolean;
};

export function todayWideSideFitsAtWidth(
  contentWidth: number,
  requiredWidth: number,
  sideCurrentlyVisible: boolean
): boolean {
  const threshold = sideCurrentlyVisible
    ? requiredWidth - DASHBOARD2_TODAY_WIDE_SIDE_HIDE_HYSTERESIS_PX
    : requiredWidth;

  return contentWidth >= threshold;
}

export function resolveTodayWideSideVisibility(
  input: TodayWideSideVisibilityInput
): TodayWideSideVisibilityResult {
  const showInlineAdditionalBookings =
    input.hasListedAdditionalBookings &&
    todayWideSideFitsAtWidth(
      input.contentWidth,
      DASHBOARD2_TODAY_SIDE_BOOKINGS_FIT_MIN_WIDTH_PX,
      input.sideCurrentlyVisible
    );

  const showHintSide =
    input.additionalCount === 0 &&
    todayWideSideFitsAtWidth(
      input.contentWidth,
      DASHBOARD2_TODAY_WIDE_HINT_FIT_MIN_WIDTH_PX,
      input.sideCurrentlyVisible
    );

  return {
    showSideContent: showInlineAdditionalBookings || showHintSide,
    showInlineAdditionalBookings
  };
}
